import { createRouter, createWebHistory } from "vue-router";
import { routerGuard } from "./routerGuard";

import UserRoutes from "@/modules/users";
import BookingRoutes from "@/modules/bookings";
import posRoutes from "@/modules/pos";
import BusRoutes from "@/modules/bus-management";
import PaymentRoutes from "@/modules/payments";
import MarketingRoutes from "@/modules/marketing";
import ActivityManagementRoutes from "@/modules/activity-management";

const routes = [
  {
    path: "/",
    meta: { title: "Dashboard" },
    name: "Home",
    component: () => import("@/modules/dashboard/views/Home.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/modules/auth/views/Login.vue"),
  },
  ...UserRoutes,
  ...BookingRoutes,
  ...posRoutes,
  ...BusRoutes,
  ...PaymentRoutes,
  ...MarketingRoutes,
  ...ActivityManagementRoutes,
  {
    path: "/settings",
    name: "Settings",
    component: () => import("@/shared/components/Settings.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/shared/components/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(routerGuard);
export default router;